module.exports = __webpack_public_path__ + "static/media/YF83_8.4da8242b.jpg";